import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotThreshold, UpdateSnapshotThresholdDto } from 'types';

export const updateThreshold = ({
  data,
  snapshotId,
  thresholdId,
}: {
  data: UpdateSnapshotThresholdDto;
  snapshotId: number;
  thresholdId: number;
}): Promise<SnapshotThreshold> => {
  return axios.put(
    `/api/snapshots/${snapshotId}/thresholds/${thresholdId}`,
    data
  );
};

type UseUpdateSnapshotOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof updateThreshold>;
};

export const useUpdateThreshold = ({
  config,
  snapshotId,
}: UseUpdateSnapshotOptions) => {
  return useMutation({
    onMutate: async (updatingThreshold) => {
      await queryClient.cancelQueries([
        'snapshot',
        snapshotId,
        'thresholds',
        updatingThreshold.thresholdId,
      ]);

      const previousThreshold = queryClient.getQueryData<SnapshotThreshold>([
        'snapshot',
        snapshotId,
        'thresholds',
        updatingThreshold.thresholdId,
      ]);

      queryClient.setQueryData(
        ['snapshot', snapshotId, 'thresholds', updatingThreshold.thresholdId],
        {
          ...previousThreshold,
          ...updatingThreshold.data,
          id: updatingThreshold.thresholdId,
        }
      );

      return previousThreshold;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: updateThreshold,
  });
};
